const PRE_LAYOUT_DESIGN_VERSION = 1;

const DC_PLOT_ROW_HEIGHT = 120;
const DC_PLOT_WIDTH = 500;
const DC_PLOT_COMP_WIDTH = 120;
const DC_PLOT_COMP_HEIGHT = 80;
const DC_PLOT_BOTTOM = 30;
const AC_PLOT_POWER_HEIGHT = 40;
const AC_PLOT_POWER_NET_HEIGHT = 80;
const AC_PLOT_NET_SPACE = 120;
const AC_PLOT_MODEL_SPACE = 120;
const AC_PLOT_MODEL_HEIGHT = 55;

const SCHEMATIC = 'schematic', SPICE = 'spice'

export {
  PRE_LAYOUT_DESIGN_VERSION,
  DC_PLOT_ROW_HEIGHT,
  DC_PLOT_WIDTH,
  DC_PLOT_COMP_WIDTH,
  DC_PLOT_COMP_HEIGHT,
  DC_PLOT_BOTTOM,
  AC_PLOT_POWER_HEIGHT,
  AC_PLOT_POWER_NET_HEIGHT,
  AC_PLOT_NET_SPACE,
  AC_PLOT_MODEL_SPACE,
  AC_PLOT_MODEL_HEIGHT,
  SPICE,
  SCHEMATIC
}